'use client';

import Icon from '@/components/ui/AppIcon';

interface ProgramComparisonProps {
  isVisible: boolean;
  onClose: () => void;
}

const ProgramComparison = ({ isVisible, onClose }: ProgramComparisonProps) => {
  const comparisonData = [
  {
    category: 'Curriculum',
    farmsForThought: 'We offer a unique curriculum that teaches high-demand technical skills such as coding and engineering fundamentals in addition to plant science and food justice, preparing students for college and beyond',
    otherPrograms: 'Do not offer technical education to prepare students for industry and beyond'
  },
  {
    category: 'Implementation',
    farmsForThought: 'Our plug and play design allows each machine to be put in a classroom without renovations',
    otherPrograms: 'Require room renovation or serious modifications. Cost > $200,000'
  },
  {
    category: 'Vertical Farm',
    farmsForThought: 'Our in-house technology is intentionally transparent to allow students to build and interact with the hardware',
    otherPrograms: 'Use technology that keeps core components out of sight, hindering technical learning.'
  }];


  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-secondary/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-background rounded-xl shadow-brand-lg max-w-6xl w-full max-h-[90vh] overflow-hidden">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-2xl font-semibold text-text-primary">
            Why Us?
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-surface rounded-lg transition-colors duration-300">

            <Icon name="XMarkIcon" size={24} variant="outline" className="text-text-secondary" />
          </button>
        </div>

        <div className="overflow-x-auto p-6">
          <table className="w-full">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-4 px-6 text-base font-semibold text-text-primary w-1/4">
                  
                </th>
                <th className="text-left py-4 px-6 text-base font-semibold text-brand-primary">Farms For Thought

                </th>
                <th className="text-left py-4 px-6 text-base font-semibold text-text-primary">
                  Other Programs
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) =>
              <tr key={index} className="border-b border-border hover:bg-surface transition-colors duration-300">
                  <td className="py-6 px-6 text-base font-semibold text-text-primary align-top">
                    {row.category}
                  </td>
                  <td className="py-6 px-6 text-sm text-text-secondary align-top">
                    {row.farmsForThought}
                  </td>
                  <td className="py-6 px-6 text-sm text-text-secondary align-top">
                    {row.otherPrograms}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>);

};

export default ProgramComparison;